import { render, staticRenderFns } from "./ModifyPass.vue?vue&type=template&id=09c70844&scoped=true&"
import script from "./ModifyPass.vue?vue&type=script&lang=js&"
export * from "./ModifyPass.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPass.vue?vue&type=style&index=0&id=09c70844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c70844",
  null
  
)

export default component.exports